<template>
  <main class="login-page">
    <LanguageChoice />

    <div class="container">
      <div v-if="tokenStatus != 'Expired'"
           class="form"
      >
        <form action="#"
              class="login-form"
              @submit.prevent="handleSignUpSubmit(email, password)"
        >
          <MainInput :text="email"
                     type="text"
                     name="email"
                     :placeholder="$t('register.email')"
                     @value-changed="setEmail"
          />
          <MainInput :text="password"
                     type="password"
                     name="password"
                     :placeholder="$t('register.password')"
                     @value-changed="setPassword"
          />
          <MainInput :text="repeatPassword"
                     type="password"
                     name="repeatPassword"
                     :placeholder="$t('register.repeatPassword')"
                     @value-changed="setRepeatPassword"
          />
          <MainButton :button-text="resetPage ? $t('register.changePassword') : $t('register.signUp')"
                      type="submit"
                      style="height: 50px; margin-bottom: 1rem;"
          />
          <a type="submit"
             class="forgot-password-link"
             style="color: white"
             @click="handleSignUp"
          >{{ $t("register.backToLogin") }}</a>
        </form>
      </div>
    </div>
  </main>
</template>

<script setup>
import { onMounted, ref, reactive } from 'vue'
import { useToast } from 'vue-toastification'
import { Register } from '@/api/account.js'
import i18n from '../locales/i18n'
import { useStore } from 'vuex'
import MainButton from '@/components/buttons/MainButton.vue'
import MainInput from '@/components/inputs/MainInput.vue'
import router from '@/router'
const store = useStore()
const toast = useToast()

// refs == single value
// const type = ref('SignIn');

const repeatPassword = ref('')
const setRepeatPassword = (e) => {
  repeatPassword.value = e.target.value
}

const password = ref('')
const setPassword = (e) => {
  password.value = e.target.value
}

const email = ref('')
const setEmail = (e) => {
  email.value = e.target.value
}

const tokenStatus = ref('')

const resetPage = ref(false)

// reactive == object/list
const postObject = reactive({})

onMounted(async () => {
  store.commit('sidebar/setCurrentPageHeaderText', i18n.global.t('sidebar.register'))
  if (window.location.href.indexOf('/reset') > -1) resetPage.value = true

  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  email.value = urlParams.get('em')
  // så ska den se ut egentligen.
  if (urlParams.has('at') && urlParams.has('em')) {
    postObject.Email = urlParams.get('em')
    postObject.Token = urlParams.get('at')
  } else {
    tokenStatus.value = 'Expired'
    router.push('/')
    toast.error(i18n.global.t('register.expiredCode'))
  }
})
function handleSignUp () {
  router.push('/')
}
async function handleSignUpSubmit () {
  try {
    if (tokenStatus.value === 'Expired') {
      toast.error(i18n.global.t('register.expiredCode'))
    } else {
      if (password.value.length < 8 || repeatPassword.value.length < 8) {
        toast.warning(i18n.global.t('register.passwordLength'))
        return
      }

      if (password.value === repeatPassword.value) {
        postObject.NewPassword = password.value
        const UserRegisterationRes = await Register(postObject)
        if (UserRegisterationRes.status === 200) {
          toast.success(
            resetPage.value
              ? i18n.global.t('register.userPasswordChanged')
              : i18n.global.t('register.userCreated')
          )
          window.setTimeout(function () {
            router.push('/')
          }, 1000)
        } else {
          toast.error(

            i18n.global.t('register.somethingWrong') +
              '\r\n\r\n' +
              UserRegisterationRes.data.message
          )
          // console.log(UserRegisterationRes.data.message)
        }
      } else {
        toast.warning(i18n.global.t('register.passwordMatchFail'))
      }
    }
  } catch (error) {
    // console.log(error)
    toast.error(i18n.global.t('register.somethingWrong') + '\r\n\r\n' + error.message)
  }
}
</script>

<style lang="scss" scoped>

.passwordReset-form {
  width: 100% !important;
}

#prForm {
  max-width: 500px;
  width: 492px;
}
.login-page {
  height: 100vh;
  overflow-y: scroll;
  background: linear-gradient(90deg, var(--gray) 0%, var(--background2) 10px);
}

.form .btn[data-v-26084dc2] {
  margin: 25px 0px 15px 0px;
}

.forgot-password-link {
  cursor: pointer;
  text-decoration: underline;
}
.forgot-password-link:hover {
  color: white;
}

.container {
  padding: 8% 0 0;
  width: 565px;
  margin: auto;
}
.offline-message-link {
  cursor: pointer;
  text-decoration: underline;
  color: white;
  display: block;
  margin-top: 1rem;
}

.offline-message-form {
  background: linear-gradient(90deg, var(--gray) 0%, var(--background2) 10px);
}

.offline-message-link:hover {
  color: white;
}
.form {
  position: relative;
  z-index: 1;
  max-width: 350px;
  margin: 0 auto 100px;
  padding: 45px;
  background: var(--mainBlue);
  border-radius: 20px;
}

.form .register-form {
  display: none;
}

@media (max-width: 768px) {
  .container {
    padding: 8% 0 0;
    margin: auto;
  }

  .form {
    position: relative;
    z-index: 1;
    max-width: 250px;
    margin: 0 auto 100px;
    padding: 25px;
    border-radius: 20px;
  }
}
</style>
